export default {
  state: {
    servers: [],
    serversFilter: [],
    serversMeta: {},
    serverErrorMsg: null,
    serverHealthChecks: {},
  },
  getters: {
    servers: state => state.servers,
    serversFilter: state => state.serversFilter,
    serversMeta: state => state.serversMeta,
    serverErrorMsg: state => state.serverErrorMsg,
    serverHealthChecks: state => state.serverHealthChecks,
  },
  mutations: {
    SET_SERVERS(state, payload) {
      state.servers = payload
      state.serversFilter = payload
    },
    ADD_NEW_SERVER(state, payload) {
      state.servers.push(payload)
    },
    REMOVE_SERVERS(state, payload) {
      state.servers = state.servers.filter(
        server => !payload.includes(server.suid)
      )
    },
    SET_SERVERS_META(state, payload) {
      state.serversMeta = payload
    },
    SET_SERVER_ERROR_MESSAGE(state, payload) {
      state.serverErrorMsg = payload
      setTimeout(() => {
        state.serverErrorMsg = null
      }, 3000)
    },
    SET_SERVER_HEALTH_CHECK(state, { suid, data }) {
      state.serverHealthChecks = { ...state.serverHealthChecks, [suid]: data }
    },
  },
  actions: {
    setServers({ commit }, payload) {
      commit('SET_SERVERS', payload)
    },
    addNewServer({ commit }, payload) {
      commit('ADD_NEW_SERVER', payload)
    },
    removeServers({ commit }, suid) {
      commit('REMOVE_SERVERS', suid)
    },
    setServersMeta({ commit }, payload) {
      commit('SET_SERVERS_META', payload)
    },
    setServerErrorMessage({ commit }, payload) {
      commit('SET_SERVER_ERROR_MESSAGE', payload)
    },
    setServerHealthCheck({ commit }, payload) {
      commit('SET_SERVER_HEALTH_CHECK', payload)
    },
  },
}
